import React from 'react';
import {FormField, FormSection, FormActions} from '../../../Presentation/components/common';
import {useFormState, CommonValidationRules, createFieldProps} from '../../../Presentation/utils/formUtils';
import {CreateBrandDTO, UpdateBrandDTO} from '../models/brand.dto';

interface BrandFormProps {
  initialData?: {
    name?: string;
    logo_url?: string;
    description?: string;
    website?: string;
  };
  onSubmit: (data: CreateBrandDTO | UpdateBrandDTO) => void;
  onCancel: () => void;
  submitting?: boolean;
  isEdit?: boolean;
}

const BrandForm: React.FC<BrandFormProps> = ({initialData = {}, onSubmit, onCancel, submitting, isEdit = false}) => {
  // Centralized form state
  const [formState, formActions] = useFormState(
    {
      name: initialData.name || '',
      logoUrl: initialData.logo_url || '',
      description: initialData.description || '',
      website: initialData.website || ''
    },
    {
      name: {
        required: !isEdit,
        customValidator: (value: string) => {
          if (!isEdit && !value?.trim()) {
            return 'الاسم مطلوب';
          }
          return null;
        }
      },
      logoUrl: CommonValidationRules.url,
      website: CommonValidationRules.url
    }
  );

  const handleSubmit = async (data: { name: string; logoUrl: string; description: string; website: string }) => {
    const formData = {
      ...(isEdit ? {} : {name: data.name.trim()}),
      ...(data.logoUrl.trim() && {logo_url: data.logoUrl.trim()}),
      ...(data.description.trim() && {description: data.description.trim()}),
      ...(data.website.trim() && {website: data.website.trim()})
    };

    onSubmit(formData);
  };

  return (
    <FormSection title={isEdit ? "تحديث البراند" : "إضافة براند جديد"} description={isEdit ? "قم بتحديث معلومات البراند" : "أدخل بيانات البراند الجديد"}>
      <form onSubmit={(e) => { e.preventDefault(); formActions.submit(handleSubmit); }} className="space-y-6">
        {!isEdit && (
          <FormField
            type="text"
            label="اسم البراند *"
            placeholder="أدخل اسم البراند"
            {...createFieldProps('name', formState, formActions)}
            disabled={submitting}
            autoFocus
          />
        )}

        <FormField
          type="url"
          label="رابط الشعار"
          placeholder="https://example.com/logo.png"
          {...createFieldProps('logoUrl', formState, formActions)}
          disabled={submitting}
        />

        <FormField
          type="textarea"
          label="الوصف"
          placeholder="وصف البراند..."
          rows={3}
          {...createFieldProps('description', formState, formActions)}
          disabled={submitting}
        />

        <FormField
          type="url"
          label="الموقع الإلكتروني"
          placeholder="https://www.example.com"
          {...createFieldProps('website', formState, formActions)}
          disabled={submitting}
        />

        <FormActions
          onSubmit={() => formActions.submit(handleSubmit)}
          onCancel={onCancel}
          submitLabel="حفظ"
          cancelLabel="إلغاء"
          isLoading={formState.isSubmitting || submitting}
          disabled={!formState.isValid}
        />
      </form>
    </FormSection>
  );
};

export default BrandForm;
